<template>
    <div class="container">
        <div class="trustpilot-widget" data-locale="en-GB" data-template-id="54ad5defc6454f065c28af8b"
            data-businessunit-id="55a4b2750000ff00058109a4" data-style-height="240px" data-style-width="100%"
            data-theme="light" data-tags="" data-stars="4,5" data-review-languages="en">
            <a href="https://uk.trustpilot.com/review/www.robinsandday.co.uk" target="_blank">Trustpilot</a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loaded: false,
        };
    },
    created() {
        if (!window.trustPilotScriptAdded) {
            const s = document.createElement('script');
            s.setAttribute('src', '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
            document.body.appendChild(s);
            window.trustPilotScriptAdded = true;
            s.onload = () => {
                if (this.loaded == false) {
                    window.Trustpilot.loadFromElement(this.$refs['trust-pilot-box']);
                    this.loaded = true;
                }
            };
            return;
        }
    },
    mounted() {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.$refs['trust-pilot-box']);
        }
        this.loaded = true;
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/TrustPilot.vue